<div class="shadow-none border-none w-full p-0 m-0" *ngIf="videoUrls && videoUrls.length > 0">
    <!-- Vídeo abaixo do cabeçalho -->
    <div class="ss-l-video-container-widget s-s-l-inlineDiv p-0 m-0 min-h-30rem relative"
        [style.width]="isCol4 ? '100%' : null"
        [style.max-width]="isCol4 ? '100%' : (isLandscape ? '400px' : null)"
        #inlineDiv [style.aspect-ratio]="aspectRatio">

        <!-- Vídeo -->
        <video *ngIf="selectedVideoUrl && videoUrls && videoUrls.length > 0" #videoPlayer [muted]="isMuted" 
            [autoplay]="true" [loop]="true" (click)="openModal(selectedVideoUrl)" (loadedmetadata)="onVideoLoaded()"
            class="cursor-pointer" [poster]="selectedVideoUrl.thumbnail">
            <source [src]="selectedVideoUrl.src" type="video/mp4" />
            Seu navegador não suporta a tag de vídeo.
        </video>

        <!-- Overlay Container -->
        <div class="ss-l-video-overlay">
            <!-- Top Bar -->
            <div class="top-bar" *ngIf="!loading">
                <div class="w-full flex justify-content-between align-items-center px-2">
                    <!-- Lado Esquerdo: Avatares -->
                    <div class="flex flex-wrap align-items-center w-6">
                        <p-avatarGroup styleClass="mb-0 avatar-group-container">
                            <!-- <i *ngIf="showPrevVideoButton"
                                class="pi pi-arrow-circle-left avatar-arrow cursor-pointer text-white"
                                (click)="playPrevVideo()"></i> -->
                            <p-avatar *ngIf="showPrevVideoButton" [image]="prevVideoThumbnail" size="large"
                                shape="circle"></p-avatar>
                            <p-avatar [image]="selectedVideoThumbnail" size="large" shape="circle"
                                class="current-video"></p-avatar>
                            <p-avatar *ngIf="showNextVideoButton" [image]="nextVideoThumbnail" size="large"
                                shape="circle" class="cursor-pointer"></p-avatar>
                            <p-avatar *ngIf="selectedVideoUrl" class="cursor-pointer"
                                (click)="openModal(selectedVideoUrl)" [label]="'+' + videoUrls.length" shape="circle"
                                size="large" [style]="{ 'background-color': '#9c27b0', color: '#ffffff' }"></p-avatar>
                        </p-avatarGroup>
                    </div>

                    <!-- Lado Direito: Botões -->
                    <div class="flex justify-content-end align-items-center w-6 gap-2">
                        <button class="play-pause-btn" (click)="togglePlay()" pButton pRipple>
                            <i [ngClass]="isPlaying ? 'pi pi-pause' : 'pi pi-play'"></i>
                        </button>
                        <button class="mute-unmute-btn" (click)="toggleMute()" pButton pRipple>
                            <i [ngClass]="isMuted ? 'bi bi-volume-mute-fill' : 'bi bi-volume-up'"></i>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Botão esquerdo (seta anterior) -->
            <div class="arrow-toggle-container left-arrow" *ngIf="!loading">
                <button class="circular-nav-button" pButton pRipple *ngIf="showPrevVideoButton" (click)="playPrevVideo()">
                    <i *ngIf="showPrevVideoButton" class="pi pi-chevron-left video-nav-arrow"
                        style="position: absolute;left: 19%;"></i>
                </button>
            </div>

            <div class="arrow-toggle-container right-arrow " *ngIf="!loading">
                <!-- Botão direito (seta próxima) -->
                <button class="circular-nav-button" pButton pRipple *ngIf="showNextVideoButton" (click)="playNextVideo()">
                    <i *ngIf="showNextVideoButton" class="pi pi-chevron-right video-nav-arrow"
                        style="position: absolute;right: 19%;"></i>
                </button>
            </div>


            <!-- Bottom Bar teste -->
            <!-- Bottom Bar reorganizada -->
            <div class="bottom-bar" #bottomBar *ngIf="!loading">
                <div class="col-12 product-carousel-container mb-0 p-0"
                    *ngIf="showProducts && selectedVideoUrl?.products?.length && !loading && filteredProducts.length > 0">
                    <div class="carousel-toggle-btn cursor-pointer"
                        [ngClass]="{'carousel-toggle-collapsed': showCarousel}"
                        (click)="toggleCarousel($event)">
                        <i [ngClass]="!showCarousel ? 'pi pi-chevron-down' : 'pi pi-chevron-up'" class="text-2xs"></i>
                    </div>
                    <div class="product-carousel mt-2 ss-l-product-swiper-wrapper"
                        [ngClass]="{'show-carousel': !showCarousel, 'hide-carousel': showCarousel}">
                        <!-- ✅ Setas de navegação — escondidas quando o Swiper está "locked"
                             (watchOverflow: não há slides escondidos pra navegar) -->
                        <ng-container *ngIf="!isProductSwiperLocked">
                            <div class="swiper-nav-btn-prev-prod" (click)="productSwiperRef?.swiperRef?.slidePrev()">
                                <button pButton icon="pi pi-chevron-left" class="circular-nav-button-prod"></button>
                            </div>
                            <div class="swiper-nav-btn-next-prod" (click)="productSwiperRef?.swiperRef?.slideNext()">
                                <button pButton icon="pi pi-chevron-right" class="circular-nav-button-prod"></button>
                            </div>
                        </ng-container>
                        <swiper #productSwiper *ngIf="showProducts" [slidesPerView]="1.2" [spaceBetween]="10" [loop]="false"
                            [cssMode]="true" [watchOverflow]="true" (lock)="onProductSwiperLock()" (unlock)="onProductSwiperUnlock()"
                            class="custom-swiper">
                            <ng-template swiperSlide *ngFor="let product of filteredProducts">
                                <div class="ss-g-product-card cursor-pointer" (click)="openModal(selectedVideoUrl)">
                                    <div class="ss-g-product-image">
                                        <img [src]="product.image || 'assets/imgTmp.webp'" [alt]="product.name"
                                            class="image-style" loading="lazy">
                                    </div>
                                    <div class="ss-g-product-info flex flex-column w-full overflow-hidden">
                                        <div class="ss-g-product-title prodExt2 white-space-nowrap overflow-hidden text-overflow-ellipsis">{{ product.name }}</div>
                                        <div class="ss-g-product-details">

                                            <div class="flex align-items-center">
                                                <span *ngIf="hasDiscount(product)" class="line-through mr-2">
                                                    R$ {{ product.compare_at_price }}
                                                </span>

                                                <span class="font-bold">
                                                    {{ product.price | currency:'BRL':'symbol':'1.2-2' }}
                                                </span>
                                            </div>


                                        </div>
                                    </div>

                                    

                                </div>
                            </ng-template>
                        </swiper>

                    </div>
                </div>

                <!-- linha com título + descrição e botões -->
                <div class="col-12 flex justify-content-between align-items-end  p-0"
                    *ngIf="showDescription">
                    <div class="col-12 info-container p-0">
                        <div *ngIf="showDescription && selectedVideoUrl?.description" class="description text-left">
                            <div class="text-white w-full mb-2 cursor-pointer select-none ss-l-element"
                                (click)="handleDivClick($event)">
                                {{ truncatedDesc }}
                                <a (click)="goVerMais(); $event.stopPropagation();" class="text-white cursor-pointer"
                                    *ngIf="showBtnVerMais">
                                    <b>ver mais</b>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>




